import { useContext } from 'react';
import { FontScaleContext } from '@/contexts';

/** Access the active font-size scale and switch it. Must be used within a `FontScaleProvider`. */
export const useFontScale = () => {
  const context = useContext(FontScaleContext);
  if (!context) {
    throw new Error('useFontScale must be used within a FontScaleProvider');
  }
  return context;
};
